import React from 'react';
export const MetricsTestimonialsSection = () => {
  const metrics = [{
    value: '+300',
    label: 'actividades físicas y cognitivas organizadas por niveles'
  }, {
    value: '+240',
    label: 'páginas listas para descargar e imprimir'
  }, {
    value: '5 + 1',
    label: 'módulos centrales + Módulo Maestro'
  }, {
    value: '3',
    label: 'bonos prácticos incluidos'
  }];
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-147">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-148">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-149">
          {metrics.map((m, i) => <div key={i} className="text-center bg-familia-card/40 md:bg-transparent rounded-xl p-4 md:p-0" data-id="element-150">
              <div className="text-3xl sm:text-5xl md:text-6xl font-display font-bold mb-1 md:mb-2 text-familia-cyan" data-id="element-151">
                {m.value}
              </div>
              <div className="text-[13px] sm:text-base text-white/85 font-medium leading-tight" data-id="element-152">
                {m.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};